<template>
   <div ref="productComp" class="box product-comparison pt-8 pb-7">
      <section class="custom-container-1440 text-center">
         <h2 v-text="content.header" />
         <p v-text="descriptionJoiner(content.shortDescription)" />

         <mq-layout mq="md+" class="btn-tab-container mb-6">
            <button
               v-for="(tab, index) in content.tabs"
               :key="index"
               :class="['btn-tab mb-1', { active: `${index}` === activeTabIndex }]"
               @click="activeTabIndex = `${index}`"
            >
               <i :class="tab.icon" /> {{ tab.header }}
            </button>
         </mq-layout>

         <div :class="['box-container col-container', { 'mb-3': $mq === 'sm' || $mq === 'xs' }]">
            <span
               :class="[
                  'col-container__text box-container__content',
                  { 'btn-tab': $mq === 'sm' || $mq === 'xs' },
                  { active: scope === 'fc' },
               ]"
               @click="scope = 'fc'"
               >FusionCharts libraries</span
            >
            <span class="col-container__vs">VS</span>
            <span
               :class="[
                  'col-container__text box-container__content',
                  { 'btn-tab': $mq === 'sm' || $mq === 'xs' },
                  { active: scope === 'os' },
               ]"
               @click="scope = 'os'"
               >Open Source charting libraries</span
            >
         </div>

         <mq-layout :mq="['xs', 'sm']" class="dropdown-container mb-4">
            <BaseDropdown
               v-model="activeTabIndex"
               placeholder="Choose Feature"
               :options="getDropdownData"
            />
         </mq-layout>
         <mq-layout
            mq="md+"
            :class="[
               'list-container',
               content.tabs[activeTabIndex].content.fc.length > 1 ? 'pb-4' : 'pb-10',
            ]"
         >
            <table class="comparison-table text-left">
               <tr v-for="(listContent, i) in content.tabs[activeTabIndex].content.fc" :key="i">
                  <td><span class="check-box fc_span" v-text="listContent" /></td>
                  <td>
                     <span class="check-box" v-text="content.tabs[activeTabIndex].content.os[i]" />
                  </td>
               </tr>
            </table>

            <span
               v-if="prevTab"
               class="pagination pagination-prev"
               @click="switchTab(`${Number(activeTabIndex) - 1}`)"
            >
               <i class="fc_keyboard_arrow_left" /> Prev : <i :class="prevTab.icon" />
               {{ prevTab.header }}
            </span>
            <span
               v-if="nextTab"
               class="pagination pagination-next"
               @click="switchTab(`${Number(activeTabIndex) + 1}`)"
            >
               <i :class="nextTab.icon" /> {{ nextTab.header }} : Next
               <i class="fc_keyboard_arrow_right" />
            </span>
         </mq-layout>
         <mq-layout :mq="['xs', 'sm']" class="list-container">
            <ul>
               <li v-for="(listContent, i) in content.tabs[activeTabIndex].content[scope]" :key="i">
                  <span
                     :class="['check-box fc_span', { minus: scope === 'os' }]"
                     v-text="listContent"
                  />
               </li>
            </ul>
         </mq-layout>
      </section>
   </div>
</template>

<script>
import BaseDropdown from '../core/BaseDropdown.vue';

export default {
   name: 'ProductComparisn',
   components: { BaseDropdown },
   props: {
      content: {
         type: Object,
         default: () => {},
      },
   },
   data() {
      return {
         activeTabIndex: '0',
         scope: 'fc',
      };
   },
   computed: {
      nextTab() {
         return this.content.tabs[Number(this.activeTabIndex) + 1];
      },
      prevTab() {
         return this.content.tabs[Number(this.activeTabIndex) - 1];
      },
      getDropdownData() {
         return this.content.tabs.map((i, ii) => ({
            text: i.header,
            value: `${ii}`,
         }));
      },
   },
   methods: {
      switchTab(index) {
         const scrollTo = this.$refs.productComp.offsetTop;

         this.activeTabIndex = index;
         scrollTo > 0 && fusionDesign.scroll.to(scrollTo, 1000, 'easeInOutExpo');
      },
   },
};
</script>

<style lang="scss" scoped>
.product-comparison {
   background-color: #f9f9fb;
   section {
      p {
         width: 50%;
         margin: 0 auto;
         padding-bottom: 70px;
      }

      h2 {
         font-size: 32px;
         letter-spacing: 0.5px;
         line-height: 42px;
      }

      @media only screen and (max-width: 1024px) {
         p {
            width: 70%;
         }
      }
      @media only screen and (max-width: 768px) {
         p {
            width: 80%;
         }
      }
   }
}
.btn-tab {
   border-radius: 4px;
   box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
   margin: 0 6px;
   padding: 10px 24px;
   font-size: 15px;
   line-height: 16px;
   font-weight: 600;
   border: none;
   cursor: pointer;
   transition: all ease 0.35s;
   background-color: #ffffff;

   &:focus {
      outline: none;
   }

   &:hover {
      color: #745ff9;
      box-shadow: 0 3px 5px 0 rgba(62, 57, 107, 0.2);
   }

   i {
      font-size: 14px;
      margin-right: 6px;
   }

   &.active {
      background: linear-gradient(270deg, #5b72de 0%, #745ff9 100%);
      color: #ffffff;
   }

   @media only screen and (max-width: 1024px) {
      font-size: 14px;
   }
}

.box {
   position: relative;
   &-container {
      width: 100%;
      display: table;
      &__content {
         display: table-cell;
         width: 50%;
         padding: 10px;

         &.btn-tab {
            font-size: 15px !important;
            font-weight: 600 !important;
            line-height: 16px !important;
            padding: 12px;
            text-align: center;
            width: auto;
            min-width: 230px;
            cursor: pointer;
            vertical-align: middle;
         }
      }
   }
   @media only screen and (max-width: 600px) {
      .btn-tab {
         min-width: 150px;
      }
   }
   @media only screen and (max-width: 375px) {
      .btn-tab {
         min-width: 100px;
      }
   }
}

.col-container {
   padding-bottom: 15px;
   border-bottom: 1px solid rgba(104, 105, 128, 0.12);
   &__vs {
      display: inline-block;
      height: 56px;
      width: 56px;
      background-color: #dddde2;
      border-radius: 50%;
      color: #212344;
      font-size: 22px;
      line-height: 56px;
      font-weight: bold;
   }
   &__text {
      color: #212344;
      font-size: 22px;
      font-weight: 600;
      line-height: 28px;
   }

   @media only screen and (max-width: 799px) {
      border: none;

      &__vs {
         width: 40px;
         height: 40px;
         font-size: 18px;
         line-height: 40px;
         margin: 0 10px;
      }
   }

   @media only screen and (max-width: 600px) {
      .btn-tab {
         max-width: 100px;
      }
   }

   @media only screen and (max-width: 425px) {
      &__vs {
         margin: 12px;
      }
   }
}

table.comparison-table tr:first-child td {
   padding: 20px 0.75rem 0 0.75rem;
   span {
      &::before {
         top: 26px !important;
         left: 32px;
      }
   }
}

table {
   border: none;
   tr {
      td {
         width: 50%;
         position: relative;
         .check-box {
            padding: 0 50px;
            display: block;
            padding-bottom: 10px;
         }
      }
   }
   tr td {
      border: none;
      &:first-child {
         border-right: 1px solid rgba(104, 105, 128, 0.12);
      }
   }

   tr:last-child {
      td {
         padding-bottom: 60px;
      }
   }
}

.list-container {
   position: relative;
   ul {
      padding-top: 20px;
      li {
         list-style: none;
         text-align: left;
         margin-bottom: 20px;
         position: relative;
         .check-box {
            &::before {
               top: 5px !important;
               left: 20px !important;
            }
         }
      }

      @media only screen and (max-width: 600px) {
         padding: 0;
      }
   }
}

.pagination {
   padding: 10px 24px;
   font-size: 14px;
   font-weight: 600;
   line-height: 18px;
   border-radius: 4px;
   color: #212344;
   background-color: #ffffff;
   border: 1px solid #d4dcec;
   cursor: pointer;
   transition: all ease 0.35s;

   i {
      font-size: 16px;
      margin-right: 5px;
      &.fc_keyboard_arrow_right,
      &.fc_keyboard_arrow_left {
         font-size: 20px;
      }
   }

   &-next {
      position: absolute;
      bottom: 40px;
      right: 10px;
      &:hover {
         box-shadow: -2px 2px 2px 0px rgba(104, 105, 128, 0.12);
      }
   }

   &-prev {
      position: absolute;
      bottom: 40px;
      left: 10px;
      &:hover {
         box-shadow: 2px 2px 2px 0px rgba(104, 105, 128, 0.12);
      }

      i:last-child {
         margin-left: 5px;
      }
   }
}

.container {
   @media only screen and (max-width: 1199px) {
      padding: 0 6rem;
   }
}

.box {
   .check-box {
      padding: 0 50px;
      display: block;
      padding-bottom: 10px;

      &.fc_span {
         &::before {
            content: '\e876';
            position: absolute;
            font-family: 'fusion-icon';
            top: 13px;
            left: 32px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            text-align: CENTER;
            line-height: 17px;
            font-size: 10px;
            color: #48b884;
            background-color: rgba(109, 198, 157, 0.15);
         }
      }

      &.fc_span.minus {
         &::before {
            content: '-';
            color: #8786a4;
            background-color: rgba(104, 105, 128, 0.14);
            line-height: 9px;
            font-size: 16px;
         }
      }

      &::before {
         content: '-';
         position: absolute;
         top: 13px;
         left: 32px;
         width: 16px;
         height: 16px;
         color: #8786a4;
         background-color: rgba(104, 105, 128, 0.14);
         border-radius: 50%;
         text-align: CENTER;
         line-height: 13px;
      }
   }
}
</style>
